// src/pages/units/UnitsTable.jsx
import React, { useMemo, useState, useEffect } from "react";
import { App, FloatButton } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useUI } from "@/context/UIContext";

import MobileCategories from "@/components/MobileCategories.jsx";
import FlatRow from "@/components/FlatRow.jsx";
import useUnits from "./hooks/useUnits";

export default function UnitsTable() {
  const { message } = App.useApp();
  const { data = [], loading, reload, create, updateName, remove } = useUnits();
  const { searchQuery, setHeaderTitle } = useUI();

  const [showRootDraft, setShowRootDraft] = useState(false);
  const [rootName, setRootName] = useState("");

  useEffect(() => {
    setHeaderTitle("Одиниці виміру");
    return () => setHeaderTitle("WHFOF");
  }, [setHeaderTitle]);

  const dataSource = useMemo(() => {
    const q = (searchQuery || "").trim().toLowerCase();
    return q ? data.filter((x) => (x.name || "").toLowerCase().includes(q)) : data;
  }, [data, searchQuery]);

  const saveRoot = async () => {
    const name = rootName.trim();
    if (name.length < 2) {
      message.warning("Назва має містити щонайменше 2 символи");
      return;
    }
    await create(name);
    setRootName("");
    setShowRootDraft(false);
    await reload();
  };

  const onRename = async (id, nextName) => {
    const name = (nextName || "").trim();
    if (name.length < 2) {
      message.warning("Назва має містити щонайменше 2 символи");
      return false;
    }
    await updateName(id, name);
    await reload();
    message.success("Назву оновлено");
    return true;
  };

  // нормализуем id, на случай если придёт объект
  const getId = (arg) =>
    typeof arg === "string" ? arg : arg?._id ?? arg?.id ?? arg?.value ?? arg?.key ?? null;

  // прямое удаление (подтверждение уже делает Popconfirm в FlatRow)
  const doDelete = async (arg) => {
    const id = getId(arg);
    if (!id) {
      message.error("Не знайдено ідентифікатор елемента");
      return;
    }
    try {
      await remove(id);
      await reload();
      message.success("Елемент видалено");
    } catch {
      message.error("Не вдалося видалити елемент");
    }
  };

  return (
    <>
      <MobileCategories
        mode="flat"
        RowComponent={FlatRow}
        loading={loading}
        dataSource={dataSource}
        /** черновик */
        rootName={rootName}
        setRootName={setRootName}
        saveRoot={saveRoot}
        setShowRootDraft={setShowRootDraft}
        draftConfig={{ title: "Нова одиниця", placeholder: "Назва одиниці" }}
        forceShowRootDraft={showRootDraft}
        /** flat-режиму достаточно onRename/onDelete */
        onRename={onRename}
        onDelete={doDelete}    // ← без дополнительных модалок
        onRemove={doDelete}    // ← на случай другого имени пропса
      />

      {!showRootDraft && (
        <FloatButton
          icon={<PlusOutlined />}
          type="primary"
          shape="circle"
          tooltip="Додати одиницю"
          onClick={() => setShowRootDraft(true)}
          style={{
            right: 16,
            bottom: "calc(env(safe-area-inset-bottom, 0px) + 16px)",
            boxShadow: "0 10px 24px rgba(0,0,0,.18)",
          }}
        />
      )}
    </>
  );
}
